export default "__VITE_ASSET__B5gFXI92__"